import type { Locale } from '@/i18n/translations';
import type { Project } from './giving';
import { DonorError, send } from './http';

export const givingFundKinds = ['tithe', 'general-fund'] as const;
export type GivingFundKind = (typeof givingFundKinds)[number];

export async function readGivingFund(
  churchId: string,
  kind: GivingFundKind,
  locale: Locale,
  signal: AbortSignal,
): Promise<Project | null> {
  try {
    const fund = await send<Project>(`/public/organizations/${churchId}/projects/${kind}`, locale, {
      signal,
    });
    return fund.status === 'PUBLISHED' && ['RON', 'EUR', 'USD'].includes(fund.currency)
      ? fund
      : null;
  } catch (error) {
    if (error instanceof DonorError && error.status === 404) return null;
    throw error;
  }
}

/** A church's tithe goes to its conference; its budget stays at that church. */
export function isChurchGivingFund(
  fund: Project | null | undefined,
  kind: GivingFundKind,
  churchId: string,
  conferenceId: string,
): fund is Project {
  return (
    !!fund &&
    (kind === 'tithe'
      ? fund.fundType === 'TITHE' && fund.organizationId === conferenceId
      : fund.isGeneralFund && fund.organizationId === churchId)
  );
}
